import { SubscriptionSummaryModel } from 'src/app/models/subscription-summary/subscription-summary-model';
import { SubscriptionVehicleModel } from 'src/app/models/subscription-vehicle/subscription-vehicle-model';
import { SubscriptionVehiclePageable } from 'src/app/models/subscription-vehicle/subscription-vehicle-pageable';
import { SubscriptionSummary, SubscriptionUser, SubscriptionUsersList, SubscriptionUsersPagedList, Vehicle, VehiclePagedList } from 'src/swagger-gen/web-secured/models';
import { AuthSupportRepoModelMapper } from '../../auth-support/mapper/auth-support-mapper';
import { EnergyRepoModelMapper } from '../../energies/mapper/model/energy-mapper';
import { SubscriptionUserPageable } from 'src/app/models/subscription-user/subscription-user-pageable';
import { SubscriptionUserModel } from 'src/app/models/subscription-user/subscription-user-model';

export class SubscriptionRepoModelMapper {

    static toSubscriptionUserPaged(r: SubscriptionUsersPagedList): SubscriptionUserPageable {
        return {
            pageable: {
                offset: r.paging.offset ?? 0,
                pageSize: r.paging.curItems,
                totalSize: r.paging.totalItems
            },
            data: SubscriptionRepoModelMapper.toSubscriptionUserList(r.list ?? [])
        };
    }

    static toSubscriptionUserList(r: SubscriptionUsersList): SubscriptionUserModel[] {
        return r.map(SubscriptionRepoModelMapper.toSubscriptionUser);
    }

    static toSubscriptionUser(r: SubscriptionUser): SubscriptionUserModel {
        return {
            email: r.email,
            firstName: r.firstName,
            lastName: r.lastName,
            subscribedDate: r.subscribedDate,
            uid: r.uid,
            authSupports: AuthSupportRepoModelMapper.toAuthSupportSummaryList(r.authSupports)
        };
    }

    static toSubscriptionVehiclePaged(r: VehiclePagedList): SubscriptionVehiclePageable {
        return {
            pageable: {
                offset: r.paging.offset ?? 0,
                pageSize: r.paging.curItems,
                totalSize: r.paging.totalItems
            },
            data: SubscriptionRepoModelMapper.toSubscriptionVehicleList(r.list || [])
        };
    }

    static toSubscriptionVehicleList(r: Vehicle[]): SubscriptionVehicleModel[] {
        return r.map(SubscriptionRepoModelMapper.toSubscriptionVehicle);
    }

    static toSubscriptionVehicle(r: Vehicle): SubscriptionVehicleModel {
        return {
            uid: r.uid,
            code: r?.code ?? '',
            energies: r.energies ? r.energies?.map(EnergyRepoModelMapper.toEnergy) : [],
            subscription: r.subscription ? SubscriptionRepoModelMapper.toSubbscriptionSummaryModel(r.subscription) : null,
            authSupports: r.authSupports || [],
            plateNumber: r.plateNumber,
            model: r.model ?? '',
            parkNumber: r.parkNumber ?? '',
            powerMax: r.powerMax ?? '',
            type: r.type
        };
    }

    static toSubbscriptionSummaryModel(r: SubscriptionSummary): SubscriptionSummaryModel {
        return {
            uid: r.uid,
            name: r.name ?? ''
        };
    }
}
